import { Modal } from 'hljd'
import { LIVE_MANAGE_PATH } from '@constant'
import { hashHistory } from 'react-router'

const goInvest = () => {
  hashHistory.push(`${LIVE_MANAGE_PATH}/LiveAccountRecharge`)
}

export default () => {
  Modal.confirm({
    title: '余额不足',
    content: '直播推广余额不足，请先充值',
    okText: '去充值',
    cancelText: '取消',
    onOk: goInvest
  })
}
